import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';

HiddenBanner.propTypes = {
  project: PropTypes.object.isRequired,
  creator: PropTypes.object
};

export default function HiddenBanner(props) {
  const { project, creator } = props;

  const launch = useDialogLauncher();

  function onCancel() {
    launch(DialogManager.ProjectClose.Config(project.id));
  }

  function onChangeVisibility() {
    launch(DialogManager.ProjectVisibility.Config(project.id));
  }

  return (
    <Wrapper
      color="gray"
      creator={creator}
      title={(
        <>
          Your project is currently hidden!
        </>
      )}
      subtitle={(
        <>
          Your project is not visible on the platform. To make it visible and start collaborating
          with others, update your project&apos;s visibility settings.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={onCancel}>
          Cancel project
        </ConnectButton>
        <ConnectButton onClick={onChangeVisibility} gray={true}>
          Change visibility
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
